import {
  Button,
  Fab,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  IconButton,
  TextField,
  Divider,
  FormControl,
  FormLabel,
  Stack,
  Autocomplete,
  Select,
  MenuItem,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import Modal from "../ui/Modal";
import { DatePicker, TimePicker } from "../ui/DateTimePickers";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useEffect } from "react";
import FormItem from "../ui/FormItem";
import {
  createClassSchedule,
  searchBatchDepositor,
  searchTeachersDepositor,
} from "../../api";
import { useSnackbar } from "notistack";

export default function AddClassSchedule({
  isOpen,
  close,
  batchId,
  edit,
  refresh,
  batchName,
  currentBatchDetails,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const BatchesType = [
    { name: "DAILY", label: "Daily" },
    { name: "WEEKLY", label: "Weekly" },
    { name: "CUSTOM", label: "Custom" },
  ];
  const [selectedStartDate, handleStartDateChange] = useState(
    currentBatchDetails?.startDate || dayjs()
  );

  const [selectedEndDate, handleEndDateChange] = useState(
    currentBatchDetails?.endDate || dayjs()
  );

  const [scheduleType, setScheduleType] = useState(
    currentBatchDetails?.scheduleType || "DAILY"
  );
  const [name, setName] = useState(currentBatchDetails?.name || "");
  const [selectedStartTime, handleStartTimeChange] = useState(
    currentBatchDetails?.startTime || dayjs().add(20, "m")
  );

  const [selectedEndTime, setSelectedEndTime] = useState(
    currentBatchDetails?.endTime || dayjs().add(80, "m")
  );

  const handleEndTimeChange = (date) =>
    setSelectedEndTime(
      date > selectedStartTime
        ? date.toISOString()
        : dayjs(selectedStartTime).add(30, "m").toISOString()
    );

  const [validate, setValidate] = useState(true);
  const [days] = useState([
    { name: "Su", title: "Sunday" },
    { name: "Mo", title: "Monday" },
    { name: "Tu", title: "Tuesday" },
    { name: "We", title: "Wednesday" },
    { name: "Th", title: "Thursday" },
    { name: "Fr", title: "Friday" },
    { name: "Sa", title: "Saturday" },
  ]);

  const shortNameArray = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const fullNameArray = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const [weeklyState, setWeeklyState] = useState({
    selectedDays: currentBatchDetails
      ? currentBatchDetails?.schedule.map((day) => {
          return {
            name: shortNameArray[day.day],
            title: fullNameArray[day.day],
            startTime: day.startTime || dayjs().add(20, "m"),
            endTime: day.endTime || dayjs().add(80, "m"),
          };
        })
      : [
          {
            name: "Mo",
            title: "Monday",
            startTime: dayjs().add(20, "m"),
            endTime: dayjs().add(80, "m"),
          },
        ],
  });

  const [customTimings, setCustomTimings] = useState(() => {
    if (edit && currentBatchDetails.schedule) {
      let schedule = [];
      currentBatchDetails.schedule.foreach((data) => {
        schedule.push({
          date: data.date,
          startTime: data.startTime,
          endTime: data.endTime,
        });
      });
      return schedule;
    } else
      return [
        {
          date: dayjs(),
          startTime: dayjs().add(20, "m"),
          endTime: dayjs().add(80, "m"),
        },
      ];
  });

  const handleScheduleTypeChange = (event) => {
    setScheduleType(event.target.value);
  };

  const handleDays = (day) => {
    let _selectedDays = [...weeklyState.selectedDays];
    const index = _selectedDays.findIndex((days) => days.name === day.name);
    if (index > -1) {
      return setWeeklyState({
        selectedDays: _selectedDays.filter(
          (selectedDay) => selectedDay.name !== day.name
        ),
      });
    }

    setWeeklyState({
      selectedDays: [
        ...weeklyState.selectedDays,
        {
          ...day,
          startTime: dayjs().add(20, "m"),
          endTime: dayjs().add(80, "m"),
        },
      ],
    });
  };

  const handleDayStartTimeChange = (index, time) => {
    let _selectedDays = [...weeklyState.selectedDays];
    _selectedDays[index].startTime = time.toISOString();
    setWeeklyState({
      selectedDays: _selectedDays,
    });
  };

  const handleDayEndTimeChange = (index, time) => {
    let _selectedDays = [...weeklyState.selectedDays];
    time =
      time > _selectedDays[index].startTime
        ? time.toISOString()
        : dayjs(_selectedDays[index].startTime).add(30, "m").toISOString();
    _selectedDays[index].endTime = time;
    setWeeklyState({
      selectedDays: _selectedDays,
    });
  };

  const addCustomTiming = () => {
    setCustomTimings([
      ...customTimings,
      {
        date: dayjs(),
        startTime: dayjs().add(20, "m"),
        endTime: dayjs().add(80, "m"),
      },
    ]);
  };

  const handleCustomTimingDateChange = (index, date) => {
    let _customTimings = [...customTimings];
    _customTimings[index].date = date;
    const st = dayjs(_customTimings[index].startTime).set({
      date: dayjs(date).get("date"),
      month: dayjs(date).get("month"),
      year: dayjs(date).get("year"),
    });
    const et = dayjs(_customTimings[index].endTime).set({
      date: dayjs(date).get("date"),
      month: dayjs(date).get("month"),
      year: dayjs(date).get("year"),
    });
    _customTimings[index].endTime = et.toISOString();
    _customTimings[index].startTime = st.toISOString();
    setCustomTimings(_customTimings);
  };

  const handleCustomTimingStartTimeChange = (index, time) => {
    console.log(customTimings);
    let _customTimings = [...customTimings];

    _customTimings[index].startTime = time;
    const st = dayjs(_customTimings[index].startTime).set({
      date: dayjs(_customTimings[index].date).get("date"),
      month: dayjs(_customTimings[index].date).get("month"),
      year: dayjs(_customTimings[index].date).get("year"),
    });
    _customTimings[index].startTime = st.toISOString();
    setCustomTimings(_customTimings);
  };

  const handleCustomTimingEndTimeChange = (index, time) => {
    console.log(customTimings);
    let _customTimings = [...customTimings];
    _customTimings[index].endTime = time;

    const et = dayjs(_customTimings[index].endTime).set({
      date: dayjs(_customTimings[index].date).get("date"),
      month: dayjs(_customTimings[index].date).get("month"),
      year: dayjs(_customTimings[index].date).get("year"),
    });
    console.log(dayjs(et).format("D M YYYY h mm A"));
    _customTimings[index].endTime = et.toISOString();
    setCustomTimings(_customTimings);
  };

  const removeCustomTimings = (index, time) => {
    let _customTimings = [...customTimings];
    _customTimings[index].endTime = time;

    const et = dayjs(_customTimings[index].endTime).set({
      date: dayjs(_customTimings[index].date).get("date"),
      month: dayjs(_customTimings[index].date).get("month"),
      year: dayjs(_customTimings[index].date).get("year"),
    });
    console.log(dayjs(et).format("D M YYYY h mm A"));
    _customTimings[index].endTime = et.toISOString();

    _customTimings.splice(index, 1);
    setCustomTimings(_customTimings);
  };

  useEffect(() => {
    if (name === "") {
      setValidate(true);
    } else {
      setValidate(false);
    }
  }, [name]);

  const [loading, setLoading] = useState(false);

  const [classSchedule, setClassSchedule] = useState({
    name: "",
    plannedStartDate: dayjs().toISOString(),
    plannedEndDate: dayjs().toISOString(),
    frequency: "DAILY",
    classStartTime: dayjs().toISOString(),
    classDuration: 0,
    teacherId: null,
    batchId: batchId,
    pedagogue: "LECTURE",
  });
  const pedagogueTypes = [
    {
      value: "LECTURE",
      label: "Lecture",
    },
    {
      value: "VIDEO",
      label: "Video",
    },
    {
      value: "MATERIAL",
      label: "Material",
    },
    {
      value: "TUTORIAL",
      label: "Tutorial",
    },
  ];

  const handleChange = (event) => {
    const { name, value } = event.target;
    setClassSchedule({
      ...classSchedule,
      [name]: value,
    });
  };

  const [teacherInputValue, setTeacherInputValue] = useState();
  const [teachers, setTeachers] = useState([]);
  const searchTeachers = (value) => {
    searchTeachersDepositor(value)
      .then((res) =>
        setTeachers(res.data.rows.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }));
  };

  const [batchInputValue, setBatchInputValue] = useState();
  const [batches, setBatches] = useState([]);
  const searchBatches = (value) => {
    searchBatchDepositor(value)
      .then((res) =>
        setBatches(res.data.rows.map((r) => ({ ...r, label: r.name })))
      )
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }));
  };

  const handleSubmit = () => {
    setLoading(true);

    let _formDetails;
    if (classSchedule.frequency === "DAILY") {
      _formDetails = {
        ...classSchedule,
        dailyStartTime: selectedStartTime,
        dailyEndTime: selectedEndTime,
      };
    }
    if (classSchedule.frequency === "WEEKLY") {
      _formDetails = {
        ...classSchedule,
        weeklyDays: weeklyState,
      };
    }
    if (classSchedule.frequency === "CUSTOM") {
      _formDetails = {
        ...classSchedule,
        customDates: customTimings,
      };
    }
    console.log(_formDetails);
    createClassSchedule(_formDetails)
      .then((_) => {
        enqueueSnackbar(`New Class Schedule Added`, {
          variant: "success",
        });
        close();
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      isOpen={isOpen}
      close={close}
      title={`Add Class Schedule for batch "${batchName}"`}
      loading={loading}
      action={handleSubmit}
    >
      <Stack>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Stack direction={"row"} spacing={2} alignItems="center">
            <FormItem label="Name">
              <TextField
                name="name"
                value={classSchedule.name}
                onChange={handleChange}
              />
            </FormItem>
            <FormItem label="Pedagogue">
              <Select
                name="pedagogue"
                value={classSchedule.pedagogue}
                onChange={handleChange}
              >
                {pedagogueTypes.map((type) => (
                  <MenuItem value={type.value}>{type.label}</MenuItem>
                ))}
              </Select>
            </FormItem>
          </Stack>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <FormLabel> Starts on</FormLabel>
                <DatePicker
                  value={classSchedule.plannedStartDate}
                  onChange={(date) => {
                    setClassSchedule({
                      ...classSchedule,
                      plannedStartDate: date.toISOString(),
                    });
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <FormLabel>Ends on</FormLabel>
                <DatePicker
                  value={classSchedule.plannedEndDate}
                  onChange={(date) => {
                    setClassSchedule({
                      ...classSchedule,
                      plannedEndDate: date.toISOString(),
                    });
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Stack direction={"row"} spacing={2} alignItems="center">
            <FormItem label="Class Start Time">
              <TimePicker
                value={classSchedule.classStartTime}
                onChange={(date) => {
                  setClassSchedule({
                    ...classSchedule,
                    classStartTime: date.toISOString(),
                  });
                }}
              />
            </FormItem>
            <FormItem label="Class Duration (Hours)">
              <TextField
                type="number"
                value={classSchedule.classDuration}
                name="classDuration"
                onChange={handleChange}
              />
            </FormItem>
          </Stack>
          <Stack direction={"row"} spacing={2} alignItems="center">
            <FormItem label="Teacher">
              <Autocomplete
                value={teacherInputValue}
                onChange={(_, newValue) => {
                  setClassSchedule({
                    ...classSchedule,
                    teacherId: newValue?.id,
                  });
                }}
                inputValue={teacherInputValue}
                onInputChange={(_, newInputValue) => {
                  console.log(newInputValue);
                  if (newInputValue) setTeacherInputValue(newInputValue);
                  searchTeachers(newInputValue);
                }}
                getOptionLabel={(option) => option.label}
                options={teachers}
                renderInput={(params) => <TextField {...params} />}
              />
            </FormItem>
            {!batchId && (
              <FormItem label="Batch">
                <Autocomplete
                  value={classSchedule.batchId}
                  onChange={(_, newValue) => {
                    setClassSchedule({
                      ...classSchedule,
                      batchId: newValue?.id,
                    });
                  }}
                  inputValue={batchInputValue}
                  onInputChange={(_, newInputValue) => {
                    if (newInputValue) setBatchInputValue(newInputValue);
                    searchBatches(newInputValue);
                  }}
                  getOptionLabel={(option) => option.label}
                  options={batches}
                  renderInput={(params) => <TextField {...params} />}
                />
              </FormItem>
            )}
          </Stack>

          <Grid sx={{ mt: "15px" }}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <FormLabel>When would the classes happen?</FormLabel>
                <RadioGroup
                  row
                  value={classSchedule.frequency}
                  onChange={(e) => {
                    setClassSchedule({
                      ...classSchedule,
                      frequency: e.target.value,
                    });
                  }}
                >
                  {BatchesType.map((type) => (
                    <FormControlLabel
                      value={type.name}
                      control={
                        <Radio name="checkedB" color="primary" size="medium" />
                      }
                      label={type.label}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Grid>

            {/* ====================== Start of Daily ========================= */}
            {classSchedule.frequency === "DAILY" && (
              <Grid item container xs={12}>
                <FormLabel>Timings</FormLabel>
                <Stack divider={<Divider flexItem />} spacing={1}>
                  <Stack direction={"row"} spacing={3} alignItems="center">
                    <Typography sx={{ flex: "none" }}>Daily Timing</Typography>
                    <TimePicker
                      value={selectedStartTime}
                      onChange={(date) =>
                        handleStartTimeChange(date.toISOString())
                      }
                    />
                    <TimePicker
                      value={selectedEndTime}
                      onChange={handleEndTimeChange}
                    />
                  </Stack>
                </Stack>
              </Grid>
            )}
            {/* ====================== Start of Weekly ========================= */}
            {classSchedule.frequency === "WEEKLY" && (
              <Grid item xs={12}>
                <FormLabel>Select days of the week</FormLabel>
                <Stack direction="row" spacing={2} marginTop={1}>
                  {days.map((day, index) => (
                    <Fab
                      onClick={() => handleDays(day, index)}
                      key={day.name}
                      size="medium"
                      color={
                        weeklyState.selectedDays.find(
                          (selectedDay) => selectedDay.name === day.name
                        )?.name
                          ? "primary"
                          : "default"
                      }
                    >
                      {day.name}
                    </Fab>
                  ))}
                </Stack>
                <Stack divider={<Divider flexItem />} spacing={1} marginTop={3}>
                  {weeklyState.selectedDays &&
                    weeklyState.selectedDays.map((selectedDay, index) => (
                      <Stack direction={"row"} spacing={3} alignItems="center">
                        <Typography sx={{ width: "7rem", flex: "none" }}>
                          {selectedDay.title}
                        </Typography>
                        <TimePicker
                          value={selectedDay.startTime}
                          onChange={(time) =>
                            handleDayStartTimeChange(index, time)
                          }
                        />
                        <TimePicker
                          value={selectedDay.endTime}
                          onChange={(time) =>
                            handleDayEndTimeChange(index, time)
                          }
                        />
                      </Stack>
                    ))}
                </Stack>
              </Grid>
            )}
            {/* ====================== Start of All Weekdays  ============================ */}
            {classSchedule.frequency === "All Weekdays" && (
              <Grid item container xs={12}>
                <FormLabel>Timings</FormLabel>
                <Stack divider={<Divider flexItem />} spacing={1}>
                  <Stack direction={"row"} spacing={3} alignItems="center">
                    <Typography sx={{ flex: "none" }}>
                      Monday - Friday
                    </Typography>
                    <TimePicker
                      value={selectedStartTime}
                      onChange={(date) =>
                        handleStartTimeChange(date.toISOString())
                      }
                    />
                    <TimePicker
                      value={selectedEndTime}
                      onChange={handleEndTimeChange}
                    />
                  </Stack>
                </Stack>
              </Grid>
            )}
            {/* ====================== Start of Custom  ============================ */}
            {classSchedule.frequency === "CUSTOM" && (
              <Grid item container xs={12}>
                <FormLabel>Timings</FormLabel>
                <Stack
                  divider={<Divider flexItem />}
                  spacing={1}
                  marginBottom={2}
                  marginTop={1}
                >
                  {customTimings.map((customTiming, index) => (
                    <Stack direction={"row"} spacing={3} alignItems="center">
                      <DatePicker
                        value={customTiming.date}
                        onChange={(date) =>
                          handleCustomTimingDateChange(index, date)
                        }
                      />
                      <TimePicker
                        value={customTiming.startTime}
                        onChange={(time) => {
                          console.log(time);
                          handleCustomTimingStartTimeChange(index, time);
                        }}
                      />
                      <TimePicker
                        value={customTiming.endTime}
                        onChange={(time) =>
                          handleCustomTimingEndTimeChange(
                            index,
                            time > customTiming.startTime
                              ? time
                              : dayjs(customTiming.startTime).add(30, "m")
                          )
                        }
                      />
                      <IconButton
                        onClick={(time) =>
                          removeCustomTimings(
                            index,
                            time > customTiming.startTime
                              ? time
                              : dayjs(customTiming.startTime).add(30, "m")
                          )
                        }
                      >
                        <CloseRoundedIcon />
                      </IconButton>
                    </Stack>
                  ))}
                </Stack>

                <Button size="large" onClick={addCustomTiming}>
                  + Add another date
                </Button>
              </Grid>
            )}
          </Grid>
        </LocalizationProvider>
      </Stack>
    </Modal>
  );
}
